import { Box } from '@chakra-ui/react';
import { Alert, AlertIcon } from 'components/v4';

export default function SSOStatusAlert({ isChanged }) {
    if (isChanged) {
        return (
            <Alert mb={6} status="warning" borderRadius="md">
                <AlertIcon />
                Changes detected. Please remember to save your configuration.
            </Alert>
        );
    }
    return (
        <Alert mb={6} status="info" borderRadius="md">
            <AlertIcon />
            SSO Sign In is automatically enabled if an identity provider is
            active.
            <Box as="span" fontWeight="bold" ml={1}>
                Changes are applied only after you click Save.
            </Box>
        </Alert>
    );
}
